import { SxProps } from "@mui/material";

export const styles = {
  container: {
    backgroundColor: "var(--white, #FFF)",
    borderRadius: "8px",
    border: "1px solid #EAECF0",
    background: "#FFF",
  } as SxProps,

  contentWrapper: {
    padding: "20px",
    display: "flex",
    flexDirection: "column",
    rowGap: "24px",
  } as SxProps,

  title: {
    color: "var(--black-100, #1C1C1C)",
    fontFamily: "Montserrat",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 700,
    lineHeight: "24px",
  } as SxProps,

  trophyGrid: {
    display: "flex",
    justifyContent: "space-between",
  } as SxProps,

  card: {
    display: "flex",
    flexDirection: "column",
    borderRadius: "8px",
    border: "1px solid #E4E7EC",
    width: "calc(20% - 6.4px)",
    padding: "12px",
    height: "100%",
  } as SxProps,

  trophyName: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "18px",
  } as SxProps,

  trophyDate: {
    color: "var(--Dark---1000, #111)",
    fontFamily: "Montserrat",
    fontSize: "12px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "18px",
  } as SxProps,

  bottomRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginTop: "auto",
  } as SxProps,

  teamAvatar: {
    width: "17.6px",
    height: "24px",
  } as SxProps,

  showMoreButton: {
    padding: "16px 0",
    borderRadius: "0",
  } as SxProps,
};
